import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { useMemo } from "react";
import { EvidenceType } from "../../store/onboarding/types";
import { toastr } from "react-redux-toastr";
import { addBehaviorScreenerEcgToDataPeriod } from "../../store/onboarding/actions";

const useBehaviorScreenerECG = () => {
  const dispatch = useDispatch();

  const evidencePeriodData = useSelector(
    (s: ApplicationState) => s.onboarding.evidencePeriodData
  );

  const ecg = useMemo(
    () =>
      evidencePeriodData
        ? evidencePeriodData.evidence_column_groups.find(
            (ecg) =>
              ecg.evidence_columns.some(
                (ec) => ec.evidence_type === EvidenceType.BehaviorScreener
              )
          )
        : undefined,
    [evidencePeriodData]
  );

  const onAdd = () => {
    if (ecg) {
      toastr.info(
        "Info",
        "The selected column(s) already exist."
      );
    } else {
      (dispatch(addBehaviorScreenerEcgToDataPeriod(0, 'srss')) as any)?.then(() =>
        toastr.success(
          "Success",
          "New column(s) has been successfully added to this data period."
        )
      );
    }
  };

  return {
    ecg,
    onAdd,
  };
};

export default useBehaviorScreenerECG;
